import React, { useReducer, useState } from 'react';
import colors from '../../assets/styles/colors';
import {
  LifeInsuranceContainer,
  LifeInsuranceHeader,
  LifeInsuranceHeaderTitle,
  LifeInsuranceHeaderArea,
  LifeInsuranceWrapper,
  LifeInsuranceContent,
  LifeInsuranceAddLine,
  LifeInsuranceLineFormItem,
  LifeInsuranceLineFormLabel,
  LifeInsuranceLineFormHeaderItem,
  LifeInsuranceLineFormDeleteItem
} from './styles';
import { H4, P } from '../../components/Typography/styles';
import Copyright from '../../components/Copyright';
import Alert from '../../components/Alert';
import InputDefault from '../../components/InputDefault';
import RadioButtonForm from '../../components/RadioButtonForm';
import InputPhone from '../../components/InputPhone';
import SearchField from '../../components/SearchField';
import InputDefaultMask from '../../components/InputDefaultMask';
import { SecondaryLargeButton } from '../../components/Buttons/styles';
import { Form, FormRow, FormFooter } from '../../components/FormTemplate/styles';
import { useForm, Controller } from 'react-hook-form';
import lifeInsuranceReducer from '../../store/LifeInsurance';
import INITIAL_STATE_INTERNATIONAL_OPERATIONS from '../../store/LifeInsurance/state'
import { useHistory, useLocation } from 'react-router-dom';
import { getStates } from '../../services/states';
import { getCities } from '../../services/cities';
import { default as LifeInsuranceTypes } from "../../store/LifeInsurance/types";
import { identificationType } from '../../helpers/enum';
import { handleChangeIdentification } from '../../helpers/price';
import ModalAction from '../../components/ModalAction';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import { postLifeInsurance } from '../../services/lifeInsurance';
import { getCreditById } from '../../services/credit';
import { getSolicitationById } from '../../services/solicitations';
import { setNewEstado } from '../../services/habeasData';
import Loader from '../../components/Loader';

const LifeInsurancePage = () => {
  const location = useLocation();
  const history = useHistory();
  const [lifeInsurance, setLifeInsurance] = useReducer(lifeInsuranceReducer, INITIAL_STATE_INTERNATIONAL_OPERATIONS);
  const { handleSubmit, control, register, setValue, watch, errors } = useForm({ defaultValues: lifeInsurance.beneficiaries });
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const fields = watch();

  async function initializeStateComponent() {
    try {
      setIsLoading(true);
      const states = await getStates();
      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);

      setLifeInsurance({
        type: LifeInsuranceTypes.SET_CREDIT,
        credit: creditResponse.data
      })

      setLifeInsurance({
        type: LifeInsuranceTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      })
      setStates(states.data);
      const response = await setNewEstado(location.idCredit,"EN_REGISTRO_OPERACIONES_INTERNACIONALES");
      history.push({
        pathname: '/admin/international-operations',
        idCredit: location.idCredit
      })
      setIsLoading(false);
    } catch (error) {
      
    }
  }

  async function onSubmit(data) {
    try {
      setIsLoading(true);
      let beneficiaries = lifeInsurance.beneficiaries;

      const countPercentage = beneficiaries.map((item, key) => {
        return parseFloat(fields[`tasa${key}`].replace('% ', ''));
      }).reduce(function (total, value) {
        return total + value;
      }, 0);
      

      if(countPercentage !== 100) {
        setShowWarningModal(true)

        return;
      }

      beneficiaries = beneficiaries.map(item => {
        return {
          idCredito: location.idCredit,
          nombre: data[`nombres_apellidos${item.id}`],
          identificacion: data[`documento${item.id}`].replaceAll('.', ''),
          tipoDocumento: item.tipo_documento.toUpperCase(),
          celular: data[`celular${item.id}`].replaceAll(' ', ''),
          idDepartamento: item.departamento.id,
          idCiudad: item.ciudad.id,
          porcentaje: parseFloat(data[`tasa${item.id}`].replaceAll('% ', ''))
        }
      })

      await postLifeInsurance(beneficiaries);
      setIsLoading(false);
      setShowSuccessModal(true);
    } catch (error) {
      console.log(error);
      console.log(error.response)
    }
  }

  function addBeneficiary() {
    if(lifeInsurance.beneficiaries.length < 3) {
      setLifeInsurance({
        type: LifeInsuranceTypes.SET_BENEFICIARIES,
        beneficiaries: [...lifeInsurance.beneficiaries, { id: lifeInsurance.beneficiaries.length, nombres_apellidos: '', tipo_documento: 'CC', documento: '', celular: '', departamento: '', ciudad: '', porcentaje_asignado: '', showCiudad: false, showDepartamento: false, filteredCities: [], filteredStates: [] }]
      })
    }
  }

  function deleteFieldFromStore(field) {
    let beneficiaries = lifeInsurance.beneficiaries;
    beneficiaries = beneficiaries.filter((item) => item.id !== field.id);

    setLifeInsurance({
      type: LifeInsuranceTypes.SET_BENEFICIARIES,
      beneficiaries,
    });
  }

  useState(() => {
    if(!location.idCredit) {
      return history.push('/admin/dashboard');
    }

    initializeStateComponent();
  }, [])

  function searchInState(e) {
    let beneficiaries = lifeInsurance.beneficiaries;
    const key = e.target.id.replace('departamento', '');

    beneficiaries[key].showDepartamento = true;
    beneficiaries[key].showCiudad = false;
    let filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    beneficiaries[key].filteredStates = filtered;

    setLifeInsurance({
      type: LifeInsuranceTypes.SET_BENEFICIARIES,
      beneficiaries: beneficiaries
    })
  }

  async function searchInCities(e) {
    let beneficiaries = lifeInsurance.beneficiaries;
    const key = e.target.id.replace('ciudad', '');

    beneficiaries[key].showDepartamento = false;
    beneficiaries[key].showCiudad = true;
    const filtered = cities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    beneficiaries[key].filteredCities = filtered;

    setLifeInsurance({
      type: LifeInsuranceTypes.SET_BENEFICIARIES,
      beneficiaries: beneficiaries
    })
  }

  function setSelectedDocumentType(item, name) {
    let beneficiaries = lifeInsurance.beneficiaries;
    const key = name.replace('tipo_documento', '');

    beneficiaries[key].documento = '';
    setValue(`documento${key}`, '')

    beneficiaries[key].tipo_documento = item.value;

    setLifeInsurance({
      type: LifeInsuranceTypes.SET_BENEFICIARIES,
      beneficiaries: beneficiaries
    })
  }

  async function setSelectedState(state, name) {
    try {
      setIsLoading(true);
      let beneficiaries = lifeInsurance.beneficiaries;
      const key = name.replace('departamento', '');

      const cities = await getCities(state.id);
      setCities(cities.data);

      beneficiaries[key].showCiudad = true;
      setValue(`departamento${key}`, state.nombre);
      beneficiaries[key].departamento = state;
      beneficiaries[key].ciudad = '';
      setValue(`ciudad${key}`, '');

      beneficiaries[key].showDepartamento = false;
      beneficiaries[key].showCiudad = false;

      setLifeInsurance({
        type: LifeInsuranceTypes.SET_BENEFICIARIES,
        beneficiaries: beneficiaries
      })

      setIsLoading(false);
    } catch (error) {
      console.log(error.response)
    }
  }

  function setSelectedCity(city, name) {
    let beneficiaries = lifeInsurance.beneficiaries;
    const key = name.replace('ciudad', '');

    setValue(`ciudad${key}`, city.nombre);
    beneficiaries[key].ciudad = city;
    beneficiaries[key].showCiudad = false;

    setLifeInsurance({
      type: LifeInsuranceTypes.SET_BENEFICIARIES,
      beneficiaries: beneficiaries
    })
  }

  return (
    <LifeInsuranceContainer id="life-insurance-page">
      <LifeInsuranceWrapper>
        <LifeInsuranceHeader>
          <LifeInsuranceHeaderTitle>Clientes</LifeInsuranceHeaderTitle>
          <LifeInsuranceHeaderArea>
          <H4 color={colors.textPrimary}>Seguro de vida</H4>
            <P bold color={colors.textPrimary}>
            {lifeInsurance.solicitation?.cliente.nombres} {lifeInsurance.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {lifeInsurance.solicitation?.cliente.identificacion}
            </P>
          </LifeInsuranceHeaderArea>
        </LifeInsuranceHeader>
        <LifeInsuranceContent>
          <Alert 
            default
            description="Agrega un máximo de 3 beneficiarios y distribuyendo entre ellos porcentajes hasta completar un 100%."
          />

          <Form onSubmit={handleSubmit(onSubmit)}>
            {lifeInsurance.beneficiaries.map(((item, key) => (
              <LifeInsuranceLineFormItem key={item.id}>
                <LifeInsuranceLineFormHeaderItem>
                  <LifeInsuranceLineFormLabel>Beneficiario {item.id + 1}</LifeInsuranceLineFormLabel>
                  {key > 0 && (
                    <LifeInsuranceLineFormDeleteItem onClick={() => deleteFieldFromStore(item)}>Eliminar Valor</LifeInsuranceLineFormDeleteItem>
                  )}
                </LifeInsuranceLineFormHeaderItem>
                <FormRow col="1">
                  <Controller
                    as={InputDefault}
                    control={control}
                    error={errors[`nombres_apellidos${item.id}`]}
                    label="Nombre y Apellido"
                    name={`nombres_apellidos${item.id}`}
                    id={`nombres_apellidos${item.id}`}
                    value={item.nombre}
                    register={register({ required: "Este dato es obligatorio" })} />
                </FormRow>
                <FormRow col="2">
                  <RadioButtonForm
                    label="Tipo de documento"
                    setIdentificationRadioChecked={setSelectedDocumentType}
                    selected={item.tipo_documento}
                    name={`tipo_documento${item.id}`}
                    id={`tipo_documento${item.id}`}
                    radios={[
                      { label: 'CC', value: 'CC' },
                      { label: 'CE', value: 'CE' }
                    ]} />
                  <Controller
                    name={`documento${item.id}`}
                    control={control}
                    value={item.documento}
                    render={() => (
                      <InputDefault
                        name={`documento${item.id}`}
                        label="Número de documento"
                        register={register({ required: "Este dato es obligatorio" })}
                        id={`documento${item.id}`}
                        error={errors[`documento${item.id}`]}
                        maxLength={item.tipo_documento === 'CE' ? identificationType.ce.max : identificationType.cc.max}
                        minLength={item.tipo_documento === 'CE' ? identificationType.ce.min : identificationType.ce.min}
                        onChange={e => {
                          if(item.tipo_documento === 'CE') {
                            setValue(`documento${item.id}`, e.target.value)
                          } else {
                            setValue(`documento${item.id}`, handleChangeIdentification(e.target.value))
                          }
                        }}
                      />
                    )}
                  />
                </FormRow>
                <FormRow>
                  <Controller
                    as={InputPhone}
                    control={control}
                    label="Celular"
                    name={`celular${item.id}`}
                    register={register({
                      required: "Este dato es obligatorio",
                      pattern: {
                        value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                        message: "Error en el número, ingresa uno válido",
                      },
                    })}
                    id={`celular${item.id}`}
                    error={errors[`celular${item.id}`]}
                    mask="999 999 99 99"
                    value={item.celular} />

                  <SearchField
                    label="Departamento de residencia"
                    name={`departamento${item.id}`}
                    id={`departamento${item.id}`}
                    show={item.showDepartamento}
                    list={item.filteredStates}
                    defaultValue={item.departamento.nombre}
                    selectField={setSelectedState}
                    searchInList={searchInState}
                    register={register({ required: "Este dato es obligatorio" })}
                    placeholder="Buscar..."
                    error={errors[`departamento${item.id}`]} />
                </FormRow>
                <FormRow>
                  <SearchField
                    label="Ciudad o municipio de residencia"
                    name={`ciudad${item.id}`}
                    id={`ciudad${item.id}`}
                    show={item.showCiudad}
                    list={item.filteredCities}
                    defaultValue={item.ciudad.nombre}
                    selectField={setSelectedCity}
                    searchInList={searchInCities}
                    register={register({ required: "Este dato es obligatorio" })}
                    placeholder="Buscar..."
                    error={errors[`ciudad${item.id}`]}
                    disabled={!item.departamento.id} />
                  <Controller
                    as={InputDefaultMask}
                    control={control}
                    label="Porcentaje"
                    name={`tasa${item.id}`}
                    register={register({
                      required: "Este dato es obligatorio",
                    })}
                    id={`tasa${item.id}`}
                    error={errors[`tasa${item.id}`]}
                    mask="% 999"
                    value={item.tasa}
                  />
                </FormRow>
              </LifeInsuranceLineFormItem>
            )))}
            <LifeInsuranceAddLine type="button" onClick={() => addBeneficiary()}>+ Agregar otro beneficiario</LifeInsuranceAddLine>

            <FormFooter justify="flex-end">
              <SecondaryLargeButton type="submit">Siguiente</SecondaryLargeButton>
            </FormFooter>
            {isLoading && <Loader></Loader>}
          </Form>
        </LifeInsuranceContent>
      </LifeInsuranceWrapper>
      <ModalAction
        open={showWarningModal}
        setShowModal={setShowWarningModal}
        actionFunctionDownButton={() => setShowWarningModal(false)}
        title="Revisa la suma de los porcentajes asignados, la cual debe sumar un 100%"
        actionLabelFunctionDownButton="Seleccionar"
        backgroundIcon={colors.bgTertiary}
        bodyIcon={<BsExclamation size={32} color={colors.textPrimary} />} />
      <ModalAction
        open={showSuccessModal}
        setShowModal={setShowSuccessModal}
        actionFunctionUpButton={() => history.push({
          pathname: '/admin/international-operations',
          idCredit: location.idCredit
        })}
        title="¡Muy bien!"
        description="Continúa con el proceso de Operaciones internacionales y PEPS."
        actionLabelFunctionUpButton="Continuar"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
      <Copyright />
    </LifeInsuranceContainer>
  )
}

export default LifeInsurancePage;
